<template>
  <main class="login-page">
    <div class="login-card">
      <section class="intro-panel">
        <h1 class="intro-title">地图标记工具</h1>
        <p class="intro-subtitle">在地图上轻松标记、管理和分享你的地点</p>
        <ul class="feature-list">
          <li>
            <i class="iconfont icon-dingwei feature-icon"></i>
            <div>
              <h2>灵活标记</h2>
              <p>搜索、点击、地址、截图、链接，随心标记每个地点</p>
            </div>
          </li>
          <li>
            <i class="iconfont icon-qunzu1 feature-icon"></i>
            <div>
              <h2>多人协作</h2>
              <p>分享即可加入，多人实时协作管理标记</p>
            </div>
          </li>
          <li>
            <i class="iconfont icon-chanpinjihe feature-icon"></i>
            <div>
              <h2>标记管理</h2>
              <p>标记集与分组层层整理，快速搜索与附近查找</p>
            </div>
          </li>
          <li>
            <i class="iconfont icon-fenxiang feature-icon"></i>
            <div>
              <h2>微信分享</h2>
              <p>小程序便捷分享，灵活控制分享范围</p>
            </div>
          </li>
          <li>
            <i class="iconfont icon-luxian feature-icon"></i>
            <div>
              <h2>出行规划</h2>
              <p>标记一览无余，轻松规划路线导航出发</p>
            </div>
          </li>
          <li>
            <i class="iconfont icon-shangchuanxiazai feature-icon"></i>
            <div>
              <h2>导入导出</h2>
              <p>Excel 批量导入，一键导出备份与分享</p>
            </div>
          </li>
        </ul>
      </section>
    <section class="qrcode-panel">
      <h2 class="qrcode-title">微信扫一扫</h2>
      <div class="qrcode-wrapper">
        <a-spin :spinning="spinning">
          <img
            class="qrcode-img"
            :src="qrcodeUrl"
            @load="getStatus"
            @error="handleCodeError"
            alt="微信扫一扫二维码"
          >
          <div class="qrcode-mask" v-if="isScan">
            <div>已扫描</div>
          </div>
        </a-spin>
      </div>
      <p class="qrcode-tips">扫码打开小程序/登录网页版</p>
      <p class="qrcode-tips">或微信搜索"地图标记"打开小程序</p>
    </section>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      qrcodeUrlOrigin: `//api.${window.location.hostname === 'localhost' ? 'map.e12e.com' : window.location.hostname}/generate/loginQRCode`,
      qrcodeUrl: '',
      lastTimer: '',
      spinning: true,
      isScan: false,
    };
  },
  methods: {
    refreshQRCode() {
      this.qrcodeUrl = `${this.qrcodeUrlOrigin}?longUuid=${this.longUuid}&t=${new Date().getTime()}`;
      // 10 min 后会过期，9 min 时自动刷新
      setInterval(() => {
        this.qrcodeUrl = `${this.qrcodeUrlOrigin}?longUuid=${this.longUuid}&t=${new Date().getTime()}`;
      }, 60 * 1000 * 9);
    },
    getStatus() {
      this.spinning = false;
      clearInterval(this.lastTimer);
      this.lastTimer = setInterval(async () => {
        const res = await this.$api.auth.loginStatus();
        console.log('res===', res);
        // eslint-disable-next-line eqeqeq
        if (res.data.data == 1) {
          console.log('扫描了');
          // eslint-disable-next-line eqeqeq
          this.isScan = true;
        // eslint-disable-next-line eqeqeq
        } else if (res.data.data == 2) {
          console.log('登录了！');
          this.$router.push('/main');
          clearInterval(this.lastTimer);
        }
      }, 2000);
    },
    handleCodeError() {
      this.$message.error('服务器连接失败', 2000);
    },
  },
  mounted() {
    this.longUuid = localStorage.getItem('longUuid');
    this.refreshQRCode();
  },
};
</script>

<style scoped>

.login-page {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
}

.login-card {
  display: flex;
  border: 1px solid #ebedf0;
}

.intro-panel {
  padding: 24px;
  border-right: 1px solid #ebedf0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 420px;
}

.intro-title {
  font-size: 20px;
  font-weight: 500;
  margin: 0 0 4px 0;
  color: #2c3e50;
  line-height: 1.4;
}

.intro-subtitle {
  font-size: 13px;
  margin: 0 0 14px 0;
  color: rgba(0, 0, 0, 0.45);
  line-height: 1.6;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 16px;
}

.feature-list li {
  display: flex;
  align-items: flex-start;
}

.feature-icon {
  font-size: 13px;
  margin-right: 6px;
  margin-top: 3px;
  color: rgba(0, 0, 0, 0.45);
  flex-shrink: 0;
}

.feature-list h2 {
  font-size: 13px;
  font-weight: 500;
  margin: 0 0 2px 0;
  color: #2c3e50;
}

.feature-list p {
  font-size: 12px;
  margin: 0;
  color: rgba(0, 0, 0, 0.45);
  line-height: 1.4;
}

.qrcode-panel {
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 260px;
  text-align: center;
}

.qrcode-title {
  font-size: 16px;
  font-weight: 500;
  color: #2c3e50;
  margin: 0 0 16px 0;
}

.qrcode-wrapper {
  position: relative;
  display: inline-block;
}

.qrcode-img {
  width: 200px;
  height: 200px;
  display: inline-block;
  background: #ffffff;
}

.qrcode-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.45);
  color: #ffffff;
  font-size: 14px;
}

.qrcode-tips {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  margin: 8px 0 0 0;
}

.qrcode-tips + .qrcode-tips {
  margin-top: 2px;
}
</style>
